import React from "react";

import client1 from "../../Assets/images/client-1.jpg";
import client2 from "../../Assets/images/client-2.jpg";
import client3 from "../../Assets/images/client-3.jpg";

export const testimonials = [
  {
    text: "Ann has been of incredible help to us. Ann saves a lot of time spent in shortlisting, co-ordinating for first round interviews and actually conducting the interviews. The interviews are detailed and the conversations are deep. We delegated our first round of interview to Ann and only meet the top candidates based on Ann's reports.",
    name: "Anshul Bhardwaj raj,",
    title: "Co-Founder - SkyTrust and CTO - Hirring",
    avatar: client1,
  },
  {
    text: "We are using Ann since last few weeks and below are our thoughts: We found Ann to be Unique & Powerful tool to help us in our Recruitment Process. What makes it stand out is User Friendly and hassle free experience. We are benefiting from its Fast & Accurate Matching, beautiful and well drafted reports about the Resume and Interview. We are able to save a lot of time and it is helping us in our decision making about profiles we are sharing with our end clients.",
    name: "JSV Santha Murthy,",
    title: "Founder, Bridge Management Solutions.",
    avatar: client2,
  },
  {
    text: "Ann has made a big difference in our hiring process. It reviews resumes with great accuracy and really understands what we need. The interviews are top-quality, and the suggestions for the next steps are always helpful. We've seen faster hiring and better matches because of her work.",
    name: "Shanker Madishetty,",
    title: "Founder and CEO, Techvest Global",
    avatar: client3,
  },
];

export const ctestimonials = [
  {
    text: (
      <>
        <div>
          Great experience with Ann AI interview tool. Felt like human
          interaction. One suggestion though - the questions asked were open
          ended like 'explain a usecase where you used the so so tools and tech
          stack and the challenges you faced". But, AI was expecting brief
          answers like in 2-3 sentences or so. It is difficult to answer in
          brief for such open ended questions for humans. So, it would be great
          if it can ask precise questions.
        </div>
      </>
    ),
    name: "Pavan Kumar Ramanna",
    title: "Lead Data Engineer",
  },
  {
    text: (
      <>
        <div>It was nice interview and very good response from HR</div>
      </>
    ),
    name: "Karthik K",
    title: "DevOps Engineer",
  },
  {
    text: (
      <>
        <div>
          Felt great comfort with the interview. The questions were clear and
          relevant. Voice quality and display quality were good. Overall a very
          nice experience
        </div>
      </>
    ),
    name: "Murali S",
    title: "Java Developer",
  },
  {
    text: (
      <>
        <div>Great Experience with AI interviewer!</div>
        <div>
          The AI interview was good. The AI interviewer was asking questions
          from the submitted resume. It was making sure candidate gives the
          required answer and does not mislead the AI interviewer. Follow up
          questions were great and were asked based on previous answers. Overall
          experience was great!
        </div>
      </>
    ),
    name: "Swaraj Jagade",
    title: "UI/UX DEVELOPER",
  },
  {
    text: (
      <>
        <div>
          I would like to take a moment to thank ProSapiens for providing me the
          opportunity to attend the Ann interview. As it was my first experience
          with an Al-based interview, I found it to be both interesting and
          engaging.
        </div>
        <div>
          The questions were well-structured and tested my understanding in a
          deep and comprehensive manner. I appreciated the focus on both
          technical knowledge and problem-solving skills. Overall, it was a
          valuable experience that helped me reflect on my capabilities.
        </div>
        <div>
          Thank you once again for the opportunity. I look forward to the next
          steps in the process.
        </div>
      </>
    ),
    name: "Ankur",
    title: "Java developer",
  },
  {
    text: (
      <>
        <div>
          Its user-friendly interface and natural language understanding make it
          easy to interact with, even for users with limited technical
          experience. One of its strongest features is the speed and accuracy of
          its responses, which are often contextual and helpful.
        </div>
        <div>
          Overall, Ann AI is a solid tool with a lot of promise. With continued
          development and fine-tuning, it could become a go-to solution in the
          AI assistant space.
        </div>
      </>
    ),
    name: "Praveen Kumar",
    title: "Euc Lead",
    avatar: "https://i.pravatar.cc/100?img=12",
  },
  {
    text: (
      <>
        <div>
          The AI interview experience was smooth and insightful. The questions
          were well structured, testing both my technical knowledge and problem
          solving skills. It truly reflected real world scenarios, making it a
          valuable experience.
        </div>
      </>
    ),
    name: "Murari Prasad",
    title: "QA Position",
  },
  {
    text: (
      <>
        <div>
          I was genuinely amazed when I was first interviewed by an AI agent
          a.k.a Ann for an AI role. What impressed me the most was how it asked
          follow-up questions until something was fully clarified. It didn’t
          feel like a simple Q&A session, it felt like a real human agent was
          taking my interview. It covered almost all the aspects mentioned in my
          resume.
        </div>
      </>
    ),
    name: "Anmol Dhankhar",
    title: "Senior Generative AI Engineer",
  },
  {
    text: (
      <>
        <div>
          Thanks for the feedback from Ann, it was best practice with Al one
          very good approach for the candidates.
        </div>
      </>
    ),
    name: "Umang Ameta",
    title: "Full stack Developer",
  },
  {
    text: (
      <>
        <div>
          I had the opportunity to experience an interview through the Ann AI
          tool, and I must say—it was one of the most insightful and empowering
          interviews I've ever had.
        </div>
        <div>
          What impressed me most was the depth and variety of questions: from
          scenario-based challenges to practical problem-solving and behavioral
          assessments.
        </div>
        <div>
          Ann doesn't just assess—it empowers. It evaluates candidates solely on
          their skills, behaviors, and practical knowledge, removing bias and
          building confidence.
        </div>
      </>
    ),
    name: "Srujan Harish",
    title: "Human Resources",
  },
  {
    text: (
      <>
        <div>
          I have completed the interview session through Ann AI ...it was a
          wonderful experience for me...as I got know the how questions can come
          from an answer...and there was so much learning for me.
        </div>
      </>
    ),
    name: "Jitendra Chaturvedi",
    title: "Construction safety manager",
  },
  {
    text: (
      <>
        <div>
          I found the AI based interview process to be very positive experience.
          The structured format, clear instructions and the ability to complete
          it seamlessly made it efficient and comfortable.
        </div>
        <div>
          The instant feedback and structured insights provided post interview
          were highly valuable, offering me a clear understanding of where I
          stand technically and the areas where I can focus on further growth.
        </div>
      </>
    ),
    name: "Prithvi Patil",
    title: "Devops Engineer",
  },
];